import { mapQualityFormatTransformation } from './quality-format';
import { mapResizeCropTransformation } from './resize-crop';
export const getTransformationFn = (transformationType) => ({
    ['resize']: mapResizeCropTransformation,
    ['crop']: undefined,
    ['quality']: mapQualityFormatTransformation,
    ['format']: mapQualityFormatTransformation,
    ['background']: undefined,
    ['gravity']: undefined,
    ['dpr']: undefined,
    ['effect']: undefined,
})[transformationType];
//# sourceMappingURL=mapper.js.map